import { combineReducers } from "redux";
import { getReducer as getModalsReducer } from "libs/modals";
import { paginationReducer } from "./paginationReducer";
import { userReducer } from "./userReducer";
import { pageReducer } from "./pageReducer";
import { loadingReducer } from "./loadingReducer";
import postsViewReducer from "./postsViewReducer";
import mediaLibraryViewReducer from "./mediaLibraryViewReducer";

// import postsReducer from "./entities/postsReducer";
import accountsReducer from "./entities/accountsReducer";
import feedMediaReducer from "./entities/hashtagFeedMediaReducer";
import hashtagsReducer from "./entities/hashtagFeedRecentHashtagReducer";

import collectionsReducer from "./entities/collectionsReducer";
import modalReducer from "./modalReducer";
import collectionEntriesReducer from "./entities/collectionEntriesReducer";
import collectionUsersReducer from "./entities/collectionUsersReducer";
import postsReducer from "./entities/postsReducer";
import tagTemplatesReducer from "./entities/tagTemplatesReducer";

// Forms
import postFormsReducer from "./forms/postFormsReducer";

//Content Inbox
import inboxItemsReducer from "./entities/inboxItemsReducer";
import inboxViewReducer from "./inboxViewReducer";
import { getPostFeatureReducer } from "features/post";
import { calendarReducer } from "features/calendar-new";
import { notesReducer } from "features/calendar-new/notes-model";
import { ideasReducer } from "features/calendar-new/ideas-model";
//CalendarHolidays
import { calendarFilterReducer } from "features/calendar-new/components/calendar-filter";

//Conversation Inbox
import conversationInboxReducer from "./conversationInboxReducer";

import { accountGroupsReducer } from "../features/account-groups-form/accountsGroups.model";
import { accountsStatisticsReducer } from "../pages/home/accountsStatistics.model";
import workshopReducer from "./workshopReducer";
import { getBulkModelRootReducer } from "../features/post/bulk-create/bulk-create-post.model";
import { usersEntitiesReducer } from "../entities/users";
import { accountManagingReducer } from "../features/account-managing/models/account.model";
import { instagramAccountManagingReducer } from "../features/account-managing/models/instagram-account.model";
import { accountQueueManagingReducer } from "../features/account-queue-managing/model/queue-managing-model";
import { copyQueueToAnotherAccountReducer } from "../features/account-queue-managing/model/copy-queue-to-another-account.model";
import { pauseAccountReducer } from "../pages/accounts/view/pause-account.model";
import { reconnectAccountReducer } from "../pages/accounts/view/reconnect-account.model";
import { removeAccountReducer } from "../pages/accounts/view/remove-account.model";
import { plansReducer } from "../features/plans-modal/models/plans.model";
import { changePlanReducer } from "../features/plans-modal/models/change-plan.model";
import { instagramActionsReducer } from "../features/instagram-actions/redux-model";
import { socialAccountConnectReducer } from "../features/social-account-connect/redux-model";
import { mediaPickerReducer } from "../features/media-library/components/media-picker/model";
import { selectedMediaReducer } from "../features/media-library/select-media.model";
import { collectionMediaFilesReducer } from "../features/media-library/collection-media-files.model";
import { uploadingFilesReducer } from "../features/media-library/uploading-files.model";

export default combineReducers({
  common: combineReducers({
    page: pageReducer,
    loading: loadingReducer,
  }),
  user: userReducer,

  postsView: postsViewReducer,

  entities: combineReducers({
    // posts: postsReducer,
    accounts: accountsReducer,
    users: usersEntitiesReducer,
    accountGroups: accountGroupsReducer,
    accountsStatistics: accountsStatisticsReducer,
    collections: collectionsReducer,
    collectionEntries: collectionEntriesReducer,
    collectionUsers: collectionUsersReducer,
    feedMedia: feedMediaReducer,
    inboxItems: inboxItemsReducer,
    recentHashtags: hashtagsReducer,
    posts: postsReducer,
    calendarPosts: calendarReducer,
    notes: notesReducer,
    ideas: ideasReducer,
    tagTemplates: tagTemplatesReducer,
  }),
  forms: combineReducers({
    postForms: postFormsReducer,
  }),

  mediaLibraryView: mediaLibraryViewReducer,
  inboxView: inboxViewReducer,
  pagination: paginationReducer,
  modal: modalReducer,
  ...getModalsReducer(),
  ...getPostFeatureReducer(),
  calendarFilter: calendarFilterReducer,
  conversationInbox: conversationInboxReducer,
  workshop: workshopReducer,
  accountManaging: accountManagingReducer,
  instagramAccountManaging: instagramAccountManagingReducer,
  accountQueueManaging: accountQueueManagingReducer,
  copyQueueToAnotherAccount: copyQueueToAnotherAccountReducer,
  pauseAccount: pauseAccountReducer,
  reconnectAccount: reconnectAccountReducer,
  removeAccount: removeAccountReducer,
  plans: plansReducer,
  changePlan: changePlanReducer,
  instagramActions: instagramActionsReducer,
  socialAccountConnect: socialAccountConnectReducer,
  mediaPicker: mediaPickerReducer,
  mediaPickerSelectedMedia: selectedMediaReducer,
  mediaPickerFiles: collectionMediaFilesReducer,
  mediaPickerUploads: uploadingFilesReducer,
  ...getBulkModelRootReducer(),
});
